import { CaretDownFilled, SearchOutlined } from '@ant-design/icons'
import { Button, Col, Form, Input, Row, Select, Space, Tag } from 'antd'
import 'moment/locale/zh-cn'
import React, { ReactElement, useEffect, useState } from 'react'
import { DateSelect } from '../../components/form/DateSelect'
import { SupervisorSelectModal } from '../../components/modal/SupervisorSelectModal'
import { DateTimeFormat } from '../../models/datetime'
import { getDisposeStateQuery } from '../../models/rule'
import { ProcessingParams } from '../../services/processing'

export const ProcessingDataQuery = ({
  value,
  onChange,
}: {
  value?: ProcessingParams
  onChange?: (params: ProcessingParams) => void
}): ReactElement => {
  const [form] = Form.useForm()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [selectedSupervisors, setSelectedSupervisors] = useState<any[]>([])

  useEffect(() => {
    form.setFieldsValue(value)
  }, [form, value])

  return (
    <>
      <Form
        form={form}
        onFinish={(values) => {
          const cautionTime = values.cautionTime
          const disposeTime = values.disposeTime
          const time = values.time
          onChange &&
            onChange({
              ...values,
              cautionTime: undefined,
              disposeTime: undefined,
              cautionStartTime: cautionTime?.[0]?.format(DateTimeFormat),
              cautionEndTime: cautionTime?.[1]?.format(DateTimeFormat),
              disposeStartTime: disposeTime?.[0]?.format(DateTimeFormat),
              disposeEndTime: disposeTime?.[1]?.format(DateTimeFormat),
            } as any)
        }}
      >
        <Col>
          <Row style={{ width: '100%' }} align='middle' justify='space-between'>
            <Space>
              <Button type='primary' onClick={() => setIsModalVisible(true)}>
                选择卫健委(局)
              </Button>
              <Form.Item name='status' noStyle>
                <Select
                  placeholder='处置状态'
                  allowClear
                  suffixIcon={<CaretDownFilled />}
                  style={{ width: 200 }}
                  onChange={form.submit}
                >
                  {[1, 2].map((s) => (
                    <Select.Option key={s} value={s}>
                      处置状态-{getDisposeStateQuery(s)}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='cautionTime' noStyle>
                <DateSelect
                  placeholder='预警时间筛选'
                  style={{ width: 150 }}
                  onChange={form.submit}
                />
              </Form.Item>
              <Form.Item name='disposeTime' noStyle>
                <DateSelect
                  placeholder='处置时间筛选'
                  style={{ width: 150 }}
                  onChange={form.submit}
                />
              </Form.Item>
              <Form.Item name='osIds' noStyle>
                <Input type='hidden' />
              </Form.Item>
            </Space>
            <Space>
              <Form.Item name='dataCode' noStyle>
                <Input
                  autoComplete='off'
                  placeholder='请输入风险ID'
                  style={{ width: 200 }}
                  onChange={form.submit}
                  prefix={<SearchOutlined />}
                  allowClear
                />
              </Form.Item>
              <Button type='primary' onClick={form.submit}>
                查询
              </Button>
            </Space>
          </Row>
          <Row style={{ marginTop: 10 }} align='middle'>
            {selectedSupervisors.map((s) => (
              <Tag
                key={s.osId}
                closable
                onClose={() => {
                  const selected = selectedSupervisors.filter(
                    (ss) => ss.osId !== s.osId
                  )
                  setSelectedSupervisors(selected)
                  form.setFieldsValue({
                    osIds:
                      selected.length === 0
                        ? undefined
                        : selected.map((s) => s.osId).join(','),
                  })
                  form.submit()
                }}
              >
                {s.osName}
              </Tag>
            ))}
          </Row>
        </Col>
      </Form>
      <SupervisorSelectModal
        visible={isModalVisible}
        initialValue={selectedSupervisors}
        onCancel={() => setIsModalVisible(false)}
        onOk={() => setIsModalVisible(false)}
        onChange={(s) => {
          const selected = s || []
          setSelectedSupervisors(selected)
          form.setFieldsValue({
            osIds:
              selected.length === 0
                ? undefined
                : selected.map((s) => s.osId).join(','),
          })
          form.submit()
        }}
      />
    </>
  )
}
